import { inject, computed, type Ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { auditUsersApi, type SerializedAuditUser } from '@/api/audit-users';

export function useAuditUser() {
  const { t } = useI18n();
  const auditUser = inject<Ref<SerializedAuditUser>>('currentAuditUser');
  const clearCurrentAuditUser = inject<() => void>('clearCurrentAuditUser');
  const setCurrentAuditUser = inject<(response: SerializedAuditUser) => void>('setCurrentAuditUser');

  const loggedIn = computed(() => !!auditUser?.value);
  // Sending, approving and rejecting documents sign as the employer.
  const canSignForCompany = computed(() => !!auditUser?.value?.canSignForCompany);

  async function logout() {
    try {
      await auditUsersApi.logout();
      clearCurrentAuditUser?.();
      window.location.href = '/audit/login';
    } catch (error) {
      // eslint-disable-next-line no-alert
      alert(t('user.signOutError'));
      // eslint-disable-next-line no-console
      console.error(error);
    }
  }

  return {
    auditUser,
    canSignForCompany,
    loggedIn,
    logout,
    setCurrentAuditUser,
  };
}
